module.exports = __webpack_public_path__ + "images/localizacao.webp";